import { gsap } from 'gsap'

class MobileMenu {
	constructor() {
		this.menu = document.querySelector('.mobile-menu')
		this.btnOpen = document.querySelector('.js-open-mobile-menu')
		this.btnClose = this.menu.querySelector('.mobile-menu__close')
		this.overlay = document.querySelector('.js-overlay')
		this.isOpen = false

		this.setAnimation()

		this.btnOpen.addEventListener('click', () => {
			this.timeline.play()
			this.isOpen = true
		})

		this.btnClose.addEventListener('click', () => {
			this.timeline.reverse()
			this.isOpen = false
		})

		this.overlay.addEventListener('click', () => {
			if (this.isOpen) {
				this.timeline.reverse()
				this.isOpen = false
			}
		})
	}

	setAnimation() {
		this.timeline = gsap
			.timeline({ paused: true })
			.to(this.menu, {
				opacity: 1,
				duration: 0.2
			})
			.to(this.menu, {
				x: 0,
				visibility: 'visible',
				duration: 0.3,
				ease: "power3.out"
			})
			.to(this.overlay, {
				opacity: 1,
				visibility: 'visible',
				duration: 0.4,
				ease: "power3.out"
			}, '-=0.15')
	}
}

export default new MobileMenu()
